import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCreativePerformanceFilterCleared.meta';

export const useTrackCreativePerformanceFilterCleared = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreativePerformanceFilterCleared = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackCreativePerformanceFilterCleared };
};
